
<section *ngIf='modalView === 1'>
  <div class='modal-top'>
    <h1> {{'pages.user-vehicle.editVehicle' | translate}}</h1> <button (click)='closeClick()'>&times;</button>
  </div>
  <form class='modal-middle' [formGroup] = 'this.vehiculeForm'>
    <div>
      <label for='pages.admin-vehicleMake2'>{{'pages.user-vehicle.make' | translate}}</label>
      <input
        type='text'
        id='Make2'
        placeholder= "{{'pages.user-vehicle.selectMake' | translate}}"
        formControlName='make'
        [ngClass]="{ 'error-message' : validate && f.make.errors }"
        [(ngModel)]='vehicle.make'
      >
    </div>
    <div>
      <label for='Model2'>{{'pages.user-vehicle.model' | translate}}</label>
      <input
        type='text'
        id='Model2'
        placeholder="{{'pages.user-vehicle.selectModel' | translate}}"
        formControlName='model'
        [ngClass]="{ 'error-message' : validate && f.model.errors }"
        [(ngModel)]='vehicle.model'

      >
    </div>
    <div>
      <label for='Year2'>{{'pages.user-vehicle.year' | translate}}</label>
      <input
        type='number'
        id='Year2'
        placeholder="{{'pages.user-vehicle.selectYear' | translate}}"
        formControlName='year'
        max='{{currentYear}}'
        min='1886'
        [ngClass]="{ 'error-message' : validate && f.year.errors }"
        [(ngModel)]='vehicle.year'

      >
    </div>
    <div>
      <label for='Plate2'>{{'pages.user-vehicle.licensePlate' | translate}}</label>
      <input
        type='text'
        id='Plate2'
        placeholder="{{'pages.user-vehicle.selectLicensePlate' | translate}}"
        formControlName='plate'
        [ngClass]="{ 'error-message' : validate && f.plate.errors }"
        [(ngModel)]='vehicle.plate'

      >
    </div>

  </form>
  <div class='modal-bottom'>
    <button class='bciti-button bciti-button--invisible' (click)='closeClick()'>{{'pages.user-vehicle.cancel' | translate}}</button>
    <button class='bciti-button bciti-button--blue' (click)='save()'>{{'pages.user-vehicle.save' | translate}}</button>
  </div>
</section>


<section *ngIf='modalView === 2'>
  <div class='modal-top'>
    <h1>{{'pages.user-vehicle.deleteVehicle' | translate}}</h1> <button (click)='closeClick()'>&times;</button>
  </div>
  <div style='margin-bottom: 20px;'>
    <p>{{'pages.user-vehicle.deleteVehicleMessage' | translate}}</p>
  </div>

  <div class='modal-bottom'>
    <button class='bciti-button bciti-button--invisible' (click)='closeClick()'>{{'pages.user-vehicle.cancel' | translate}}</button>
    <button class='bciti-button bciti-button--blue' (click)='saveDelete()'>{{'pages.user-vehicle.confirm' | translate}}</button>
  </div>
</section>

<section *ngIf='modalView === 3'>
  <div class='modal-top'>
    <h1>{{ 'pages.user-vehicle.addVehicle' | translate}}</h1> <button (click)='closeClick()'>&times;</button>
  </div>
  <form class='modal-middle' [formGroup] = 'this.vehiculeForm'>
    <div>
      <label for='Make'>{{'pages.user-vehicle.make' | translate}}</label>
      <input
        type='text'
        id='Make'
        placeholder= "{{'pages.user-vehicle.selectMake' | translate}}"
        formControlName='make'
        [ngClass]="{ 'error-message' : validate && f.make.errors }"

      >
    </div>
    <div>
      <label for='Model'>{{'pages.user-vehicle.model' | translate}}</label>
      <input
        type='text'
        id='Model'
        placeholder="{{'pages.user-vehicle.selectModel' | translate}}"
        formControlName='model'
        [ngClass]="{ 'error-message' : validate && f.model.errors }"

      >
    </div>
    <div>
      <label for='Year'>{{'pages.user-vehicle.year' | translate}}</label>
      <input
        type='number'
        id='Year'
        placeholder="{{'pages.user-vehicle.selectYear' | translate}}"
        formControlName='year'
        max='{{currentYear}}'
        min='1886'
        [ngClass]="{ 'error-message' : validate && f.year.errors }"
      >
    </div>
    <div>
      <label for='Plate'>{{'pages.user-vehicle.licensePlate' | translate}}</label>
      <input
        type='text'
        id='Plate'
        placeholder="{{'pages.user-vehicle.selectLicensePlate' | translate}}"
        formControlName='plate'
        [ngClass]="{ 'error-message' : validate && f.plate.errors }"

      >
    </div>

  </form>
  <div class='modal-bottom'>
    <button class='bciti-button bciti-button--invisible' (click)='closeClick()'>{{'pages.user-vehicle.cancel' | translate}}</button>
    <button class='bciti-button bciti-button--blue' (click)='save()'>{{'pages.user-vehicle.save' | translate}}</button>
  </div>
</section>


<section *ngIf='modalView === 4'>
  <div class='modal-top'>
    <h1>Select favorite vehicle</h1> <button (click)='closeClick()'>&times;</button>
  </div>
  <div>
    <p>{{'pages.user-vehicle.selectFavMessage'[0] | translate}} <p>
    <p>
      This vehicle will be
      - The first in your list
      - Selected by default when you pay for parking</p>
  </div>

  <div class='modal-bottom'>
    <button class='bciti-button bciti-button--invisible' (click)='closeClick()'>{{'pages.user-vehicle.cancel' | translate}}</button>
    <button class='bciti-button bciti-button--blue' (click)='save()'>{{'pages.user-vehicle.confirm' | translate}}</button>
  </div>
</section>